import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { Logistiques } from '../logistiques';
import { LogistiquesService } from '../logistiques.service';

@Component({
  selector: 'app-zones',
  templateUrl: './zones.component.html',
  styleUrls: ['./zones.component.css']
})
export class ZonesComponent implements OnInit, OnDestroy {
  user = JSON.parse(localStorage.getItem('user'));
  subscription: Subscription = new Subscription();
  zones: Logistiques[] = [];
  form: FormGroup;
  submitted = false;

  id: string;
  s: Logistiques;
  errorMsg = '';
  abonnes = 0;
  errorLoading = '';
  loading = true;

  constructor(
    private fb: FormBuilder,
    private modal: NgbModal,
    private service: LogistiquesService
  ) { }

  ngOnInit(): void {
    this.getZones();
    this.createForm();
  }
  getZones(): void {
    this.subscription.add(
      this.service.list('zones')
        .subscribe(
          (arg: Logistiques[]) => {
            this.zones = arg;
            this.loading = false;
          },
          erg => {
            this.errorMsg = erg.error.message;
            this.loading = false;
          }));
  }

  open(c: any): void {
    this.modal.open(c);
  }

  createForm(): void {
    this.form = this.fb.group({
      zone: ['', Validators.required],
      code: ['', Validators.required]
    });
  }

  onSubmit(): void {
    this.submitted = true;
    this.subscription.add(
      this.service.add('zones', this.form.value)
        .subscribe(arg => {
          this.getZones();
          this.modal.dismissAll();
          this.submitted = false;
        },
          erg => {
            this.errorMsg = erg.error.message;
            this.submitted = false;
          }));
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

}
